<template>
  <div class="box-border p-[10px]">
    <div
      class="w-full bg-[#000] text-[#b00b78] text-[16px] h-[40px] flex items-center justify-center mb-[10px]"
    >
      站长亲测：安全APP无毒免费下载
    </div>
    <div class="w-full grid grid-cols-4 gap-[10px]">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="bg-[#000] flex items-center justify-center rounded-[5px] w-full h-[35px] text-[#fff] text-[12px]"
        :style="{ color: colorList[Math.floor(index / 4) % colorList.length] }"
        @click="handelUrl(item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  list: {
    type: Array,
    default: () => [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
      27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40
    ]
  }
})
const colorList = [
  '#da922a',
  '#fff',
  '#16b67e',
  '#f5ef1a',
  '#15bece',
  '#dd70d5',
  '#f31900',
  '#666666',
  '#006599',
  '#993233',
  '#d98569',
  '#3e9f96'
]
const handelUrl = (item) => {
  if (item.href) {
    window.open(item.href, '_blank')
  }
}
</script>

<style></style>
